import { defineReceiver } from '@drapejs/invoker';
import { fetchPage } from '@drapejs/core';
import { batch } from '@distancify/drapejs-litium';
import { gql } from 'graphql-request';

import { isPageType } from '@/connectors/shared';

import { getBundlesCacheKey } from '@/composables/useVariantBundles';

export const scheduleAll = defineReceiver(
  fetchPage,
  async function (command: any, data) {
    if (isPageType(data, 'Product') && data.articleNumber && command.query.variant) {
      await this.invoke(batch.scheduleQuery, {
        cacheKey: getBundlesCacheKey(data.articleNumber, command.query.variant),
        query: gql`
            variantBundles(variantId: $variantId) {
                bundledVariantArticleNumber
                bundleArticleNumber
                inStock
                stock {
                  totalStockAvailable
                  currentStock {
                    amount
                    date
                  }
                  incomingStock {
                    date
                    amount
                  }
                  expectedShippingDateTime
                  deliveryDateFromSupplier
                }
                campaignPrice
                price
                bundledVariants {
                  articleNumber
                  brand
                  productName
                  url
                  image
                }
              }`,
        variables: {
          variantId: {
            value: command.query.variant || '',
            type: 'String',
          },
        },
      });
    }

    return data;
  }
);
